import { Tab } from '../../../../../../views/team/reports';

export default {
  tabs: {
    [Tab.General]: 'General',
    [Tab.SignedLive]: 'Signed / Live',
    [Tab.MRR]: 'MRR',
    [Tab.CollectedCommission]: 'Commission',
  },
};
